export default __webpack_public_path__ + "static/media/Mott.d0f78b26.png";